/* eslint-disable jsx-a11y/anchor-is-valid */
"use client";
import { useState, useRef, useEffect } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import bannerImg from "./assets/bgImage.webp"; // Adjust the import path
import { Helmet } from "react-helmet";

import "./stepstoBhakti.css"; // Import your CSS file

export default function BhaktiStepsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    bhaktiStep: "",
    passportName: "",
    spiritualName: "",
    spiritualMaster: "",
    connectedWith: "",
    contactNumber: "",
    committedRounds: "",
    genderLanguageLocation: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);


  const [dropdownOpen, setDropdownOpen] = useState(false);

  const options = [
    { value: "", label: "Select Bhakti Step" },
    { value: "shraddhavan", label: "Shraddhavan" },
    { value: "krishna-sevaka", label: "Krishna Sevaka" },
    { value: "krishna-sadhaka", label: "Krishna Sadhaka" },
    { value: "krishna-upasaka", label: "Krishna Upasaka" },
    { value: "srila-prabhupada-asrya", label: "Srila Prabhupada Asraya" },
    { value: "guru-padaasrya", label: "Guru Padaasrya" },
    { value: "first-initiation", label: "Recommendation for 1st Initiation" },
  ];

  const [errors, setErrors] = useState({
    contactNumber: "",
  });

  const validateContactNumber = (number) => {
    // Basic validation - check if it's a number and has at least 10 digits
    const phoneRegex = /^[0-9]{10,}$/; // Adjust this regex based on your requirements
    return phoneRegex.test(number);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validate contact number on change
    if (name === "contactNumber") {
      setErrors({
        ...errors,
        contactNumber: validateContactNumber(value)
          ? ""
          : "Please enter a valid phone number (at least 10 digits)",
      });
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelect = (value) => {
    setFormData((prev) => ({ ...prev, bhaktiStep: value }));
    setDropdownOpen(false);
  };

  const selectedLabel =
    options.find((o) => o.value === formData.bhaktiStep)?.label ||
    "Select Bhakti Step";
  // Ref for the dropdown to detect clicks outside of it
  const dropdownRef = useRef(null);

  // Close the dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    // Bind the event listener
    document.addEventListener("click", handleClickOutside);

    // Cleanup the event listener
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);


// {handleSubmit} 
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;
    
    setIsSubmitting(true);

    // Validate contact number before submission
    if (!validateContactNumber(formData.contactNumber)) {
      setErrors({
        ...errors,
        contactNumber: "Please enter a valid phone number (at least 10 digits)",
      });
      setIsSubmitting(false);     
      return;
    }

    try {
      // Convert formData to URL-encoded string
      const formBody = new URLSearchParams(formData).toString();

      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbxaAFVoUBhtVQ0SYYOkF06xlFMcn6TDA54we0xj0-bQ0C-au_6ZyQ-bC6lmhKN_42K2/exec",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formBody,
        }
      );

      const result = await response.text();
      console.log("Server response:", result);

      if (response.ok) {
        alert("Form submitted successfully!");
        setFormData({
          passportName: "",
          spiritualName: "",
          spiritualMaster: "",
          connectedWith: "",
          contactNumber: "",
          committedRounds: "",
          genderLanguageLocation: "",
        });

        // Optional: Refresh the page to see the new entry
        window.location.reload();
      } else {
        throw new Error(result);
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert(`Error: ${error.message}`);
    }finally{
      setIsSubmitting(false);
    }
  };




  const bannerContainerRef = useRef(null);
  const bannerRef = useRef(null);
  const contentRef = useRef(null);
  useEffect(() => {
    const handleScroll = () => {
      if (
        bannerContainerRef.current &&
        bannerRef.current &&
        contentRef.current
      ) {
        const scrollPosition = window.scrollY;
        const bannerHeight = bannerContainerRef.current.offsetHeight;

        // Only apply effects when banner is in view
        if (scrollPosition < bannerHeight) {
          // Parallax effect for background
          bannerRef.current.style.transform = `translateY(${
            scrollPosition * 0.5
          }px)`;

          // 3D effect for content
          const progress = Math.min(scrollPosition / bannerHeight, 1);
          contentRef.current.style.transform = `
            perspective(1000px) 
            translateZ(${progress * 50}px)
          `;
          contentRef.current.style.opacity = `${1 - progress * 0.3}`;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const openAndDownloadDrivePdf = (driveLink, fileName) => {
    // Extract file ID from full Google Drive link
    const match = driveLink.match(/\/d\/([a-zA-Z0-9_-]+)\//);
    if (!match) {
      console.error("Invalid Google Drive link");
      return;
    }

    const fileId = match[1];
    const viewUrl = `https://drive.google.com/file/d/${fileId}/preview`;
    const downloadUrl = `https://drive.google.com/uc?export=download&id=${fileId}`;

    // Open in new tab
    window.open(viewUrl, "_blank");

    // Download
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Helmet>
        <title>
          Steps to Bhakti – Begin Your Journey in Krishna Consciousness
        </title>
        <meta
          name="description"
          content="Learn the essential steps to bhakti with ISKCON Vijayawada—start your journey in Krishna consciousness through chanting, seva, and spiritual learning."
        />
        <meta
          name="keywords"
          content="Steps to Bhakti, Krishna consciousness guide, bhakti yoga basics, how to start devotion ISKCON"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Steps to Bhakti – Begin Your Journey in Krishna Consciousness"
        />
        <meta
          property="og:description"
          content="Learn the essential steps to bhakti with ISKCON Vijayawada—start your journey in Krishna consciousness through chanting, seva, and spiritual learning."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/StepsToBhakti"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Steps to Bhakti – Begin Your Journey in Krishna Consciousness"
        />
        <meta
          name="twitter:description"
          content="Learn the essential steps to bhakti with ISKCON Vijayawada—start your journey in Krishna consciousness through chanting, seva, and spiritual learning."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
      </Helmet>

      <Header />
      <div className="min-h-screen flex flex-col">
        <div
          ref={bannerContainerRef}
          className="relative  overflow-hidden h-[40vh] md:h-[50vh] "
        >
          {/* Banner image with parallax */}
          <div
            ref={bannerRef}
            className="absolute inset-0 bg-cover bg-center transition-transform duration-300 ease-out"
            style={{
              backgroundImage: `url(${bannerImg})`,
              willChange: "transform",
            }}
          ></div>

          {/* Dark overlay for dimming effect */}
          <div className="absolute inset-0 bg-black opacity-30"></div>

          {/* Content with 3D effect - Improved centering */}
          <div
            ref={contentRef}
            className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center text-center px-4"
            style={{
              willChange: "transform, opacity",
              transformStyle: "preserve-3d",
            }}
          >
            <div className="relative z-10 w-full max-w-4xl mx-auto">
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-3 sm:mb-4">
                Bhakti Steps
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl text-white">
                Come closer to Krishna, one step at a time
              </p>
            </div>
          </div>
        </div>
        {/* Main Content */}
        <main className="container mx-auto px-4 py-12">
          <div className="StepsToBhakti-section-heading">
            <h1 className="StepsToBhakti-heading">
              Steps to Bhakti – Your Journey to Krishna Begins Here
            </h1>
            <h2 className="StepsToBhakti-subheading">
              Discover Bhakti Yoga and Take Your First Spiritual Step
            </h2>
          </div>
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Left Content */}
            <div className="lg:w-2/3">
              <p className="mb-4">
                For the ease of devotees, the summary of this page is available
                in downloadable form -{" "}
                <a
                  href="#"
                  onClick={() =>
                    openAndDownloadDrivePdf(
                      "https://docs.google.com/spreadsheets/d/1_zMkIhUZqBz0hQUTBA3cU7kLhKyvcFE6/edit?usp=drive_link&ouid=108405986133896703014&rtpof=true&sd=true",
                      "questionnaire.pdf"
                    )
                  }
                  className="text-rose-600 hover:underline"
                >
                  Bhakti Steps Requirements
                </a>
              </p>
              <p className="mb-8">
                The recommended books can be purchased from ISKCON Vijaywada
                Gift Shop
              </p>

              {/* SHRADDHAVAN Section */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold uppercase  text-red border-b-2 border-red-700 pb-2 mb-4">
                  Bhakti Step 1 : SHRADDHAVAN
                </h2>

                <p className="mb-4">
                  Downloadable version of{" "}
                  <a href="#"
                    onClick={() => openAndDownloadDrivePdf('https://drive.google.com/file/d/1BRCf0AgOdPgBUlPyD21VuJtkReIrCcr6/view?usp=drive_link', 'questionnaire.pdf')}
                    className="text-rose-600 hover:underline">
                    questionnaire
                  </a>{" "}
                </p>

                {/* Table */}
                <div className="border border-gray-300 rounded-md overflow-hidden mb-8">
                  <table className="w-full border-collapse border-t border-l border-r border-gray-300">
                    <tbody>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Chanting- min
                          <br />
                          Rounds
                        </td>
                        <td className="py-3 pl-4">1</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Reading (Refer <br />
                          <a
                            href="#"
                            onClick={() =>
                              openAndDownloadDrivePdf(
                                "https://drive.google.com/file/d/1LNBe94H2a_R8T2DKUpDR65RqJranhalQ/view?usp=sharing",
                                "questionnaire.pdf"
                              )
                            }
                            className="text-rose-600 hover:underline"
                          >
                            reading material
                          </a>{" "}
                          for
                          <br />
                          these topics)
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            Pancha tattva mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1y8TwWMnvpStKAPsxu2ZBaHJ0UZWyTiZf/view?usp=drive_link",
                                  "Pancha tattva mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prabhupada pranam mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1AcC61DPlCO0QxOogCF7T0Ghvwr2Pmiyz/view?usp=drive_link",
                                  "Srila prabhupada pranama mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1iGD8gjbOdWiko4LOA9jsrrvMhlEborxE/view?usp=drive_link",
                                  "Sikshastakam.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              Sikshastakam
                            </a>
                          </p>
                          <p className="mb-2">
                            Ten offenses to be avoided (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/19iiEken2dZIsRyY85_aFRVeyNmreqwtG/view?usp=drive_link",
                                  "Ten offenses to be avoided.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            Prayers for offering Bhoga (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1qK7iqtFbox7TfmdyI1uRoVrSFLQ07o0Z/view?usp=drive_link",
                                  "Prayers for offering Bhoga.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prasadam honoring mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1fvjniWpC7s_CNx_nz69CUF7BOzaCFHKx/view?usp=drive_link",
                                  "Prasadam honoring mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Hearing
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">Recommended- SP's BG classes</p>
                          <p>
                            (BG Chapter 1 -{" "}
                            <a
                              href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_01"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Rules and Regulation
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            * I will read the teachings of Lord Krishna as given
                            in the books of Srila Prabhupada.
                          </p>
                          <p>
                            * I will be an active devotee in the temple's
                            congregation, that is, I will visit the temple as
                            often as possible participate and associate with
                            Krishna Conscious programs & festivals in the
                            temple.
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Writing Shiksha
                          <br />
                          Paper
                        </td>
                        <td className="py-3 pl-4">
                          <p>An open book test</p>
                          <p>
                            (
                            <a
                              href="#"
                              onClick={() => openAndDownloadDrivePdf('https://drive.google.com/file/d/1BRCf0AgOdPgBUlPyD21VuJtkReIrCcr6/view?usp=drive_link', 'questionnaire.pdf')}

                              className="text-rose-500 hover:underline"
                            >
                              questionnaire
                            </a>
                            )
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Training- Attend
                          <br />
                          Seminar
                        </td>
                        <td className="py-3 pl-4">No</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Interview
                        </td>
                        <td className="py-3 pl-4">No</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Mentor/Guide
                        </td>
                        <td className="py-3 pl-4">Recommended</td>
                      </tr>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Attending Bv
                        </td>
                        <td className="py-3 pl-4">Recommended</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Krishna Sevaka Section */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold uppercase text-red border-b-2 border-red-700 pb-2 mb-4">
                  Bhakti Step 2: Krishna Sevaka
                </h2>
                <p className="mb-4">
                  Downloadable version of{" "}
                  <a href="#"
                    onClick={() => openAndDownloadDrivePdf('https://drive.google.com/file/d/1fsGvVcYfxxwA6BoATSkW3jvFV26-91DE/view?usp=drive_link', 'questionnaire.pdf')}
                    className="text-rose-600 hover:underline">
                    questionnaire
                  </a>
                </p>

                {/* Table */}
                <div className="border border-gray-300 rounded-md overflow-hidden mb-8">
                  <table className="w-full border-collapse border-t border-l border-r border-gray-300">
                    <tbody>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Chanting- min
                          <br />
                          Rounds
                        </td>
                        <td className="py-3 pl-4">4</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Reading
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            Pancha tattva mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1AiyUDZb5bliFr31I22377PZDKrT_2JEh/view?usp=drive_link",
                                  "Pancha tattva mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prabhupada pranam mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1AcC61DPlCO0QxOogCF7T0Ghvwr2Pmiyz/view?usp=drive_link",
                                  "Srila prabhupada pranama mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf("", "Sikshastakam.pdf")
                              }
                              className="text-rose-500 hover:underline"
                            >
                              Sikshastakam
                            </a>
                          </p>
                          <p className="mb-2">
                            Ten offenses to be avoided (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1YO2dBAFxP-8912moWqExso85eiTCOXeD/view?usp=drive_link",
                                  "Ten offenses to be avoided.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            Prayers for offering Bhoga (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/13t475ZAKAPnzUHFgoNRqadQ_7L9eRH-M/view?usp=drive_link",
                                  "Prayers for offering Bhoga.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prasadam honoring mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1In4ShpmB2aLgCbcsLyKcAVEYL6XAq8nW/view?usp=drive_link",
                                  "Prasadam honoring mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            <a
                              href=" https://vedabase.io/en/library/bbd/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Beyond Birth & Death
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/ssr/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Science of Self Realization
                            </a>
                            <span className="pl-2">chapter 1</span>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/bg/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Bhagavat Gita As It Is{" "}
                            </a>
                            <span className="pl-2">
                              Introduction & Chapter 1
                            </span>
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Hearing
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">Recommended- SP's BG classes</p>
                          <p>
                            (BG Chapter 1 -{" "}
                            <a
                              href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_01"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Rules and Regulation
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            * I will read the teachings of Lord Krishna as given
                            in the books of Srila Prabhupada.
                          </p>
                          <p>
                            * I will be an active devotee in the temple's
                            congregation, that is, I will visit the temple as
                            often as possible participate and associate with
                            Krishna Conscious programs & festivals in the
                            temple.
                          </p>

                          <p>
                            * Refraining from non-vegetarian food (meat, fish
                            and eggs ) and try to lead a moral life.
                          </p>
                          <p>
                            * I will be dedicated to personal improvement in
                            devotional practice and purity, by gradually
                            applying the teachings of Srila Prabhupada under the
                            guidance of his representatives.
                          </p>
                          <p>
                            * I will accept that Lord Krishna is the Supreme
                            Personality of Godhead.
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Writing Shiksha
                          <br />
                          Paper
                        </td>
                        <td className="py-3 pl-4">
                          <p>An open book test</p>
                          <p>
                            (
                            <a
                              href="#"
                              onClick={() => openAndDownloadDrivePdf('https://drive.google.com/file/d/1fsGvVcYfxxwA6BoATSkW3jvFV26-91DE/view?usp=drive_link', 'questionnaire.pdf')}
                              className="text-rose-500 hover:underline"
                            >
                              questionnaire
                            </a>
                            )
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Training- Attend
                          <br />
                          Seminar
                        </td>
                        <td className="py-3 pl-4">No</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Interview
                        </td>
                        <td className="py-3 pl-4">No</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Mentor/Guide
                        </td>
                        <td className="py-3 pl-4">Recommended</td>
                      </tr>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Attending Bv
                        </td>
                        <td className="py-3 pl-4">Recommended</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* Krishna Sadhaka */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold uppercase text-red border-b-2 border-red-700 pb-2 mb-4">
                  Bhakti Step 3: Krishna Sadhaka
                </h2>
                <p className="mb-4">
                  Downloadable version of{" "}
                  <a href="#"
                    onClick={() => openAndDownloadDrivePdf('https://drive.google.com/file/d/1f_ZoVxGhPhArNXh-xOqbtQ0PdYmB8AZx/view?usp=drive_link', 'questionnaire.pdf')}
                    className="text-rose-600 hover:underline">
                    questionnaire
                  </a>
                </p>

                <div className="border border-gray-300 rounded-md overflow-hidden mb-8">
                  <table className="w-full border-collapse border-t border-l border-r border-gray-300">
                    <tbody>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Chanting- min
                          <br />
                          Rounds
                        </td>
                        <td className="py-3 pl-4">8 to 12</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Reading (Refer <br />
                          <a
                            href="#"
                            onClick={() =>
                              openAndDownloadDrivePdf(
                                "",
                                "reading material.pdf"
                              )
                            }
                            className="text-rose-500 hover:underline"
                          >
                            reading material
                          </a>{" "}
                          for
                          <br />
                          these topics)
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            Pancha tattva mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/16DgojkisQCQu_pLfrqnv2-Bg5QBvjW4s/view?usp=drive_link",
                                  "Pancha tattva mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prabhupada pranam mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1AcC61DPlCO0QxOogCF7T0Ghvwr2Pmiyz/view?usp=drive_link",
                                  "Srila prabhupada pranama mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            <a
                              href="#"
                              className="text-rose-500 hover:underline"
                            >
                              Sikshastakam
                            </a>
                          </p>
                          <p className="mb-2">
                            Ten offenses to be avoided (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1ybzuvuIi8IYOo78jYnBvY4Cjd_W0Eoh4/view?usp=drive_link",
                                  "Ten offenses to be avoided.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            Prayers for offering Bhoga (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/10DTVIJvfa8VCwX7gxo2ZzPaLo3e8z7bd/view?usp=drive_link",
                                  "Prayers for offering Bhoga.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prasadam honoring mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1gJct5cctSez-1QarM1iScRCj5WWUywfP/view?usp=drive_link",
                                  "Prasadam honoring mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/bbd/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Beyond Birth & Death
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/ssr/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Science of Self Realization
                            </a>
                            <span className="pl-2">chapter 1 - 3</span>
                          </p>
                          <p className="mb-2">
                            <a
                              href=" https://vedabase.io/en/library/bg/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Bhagavat Gita As It Is{" "}
                            </a>
                            <span className="pl-2">chapter 1 - 3</span>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/rv/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Raja vidya
                            </a>
                          </p>
                          <p className="mb-2">Matchless Gift</p>

                          <p className="mb-2">
                            recommended
                            <a
                              href="https://vedabase.io/en/library/kb/"
                              target="_blank"
                              className="text-rose-500 hover:underline mx-1"
                            >
                              Krishna{" "}
                            </a>
                            book
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Hearing
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">Must- SP’s BG classes</p>

                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_2"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 2 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_3"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 3 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_4"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 4 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_5"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 5 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_6"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 6 –click here)</p>
                          </a>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Rules and Regulation
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            Refraining from non-vegetarian food (meat, fish and
                            eggs ) and try to lead a moral life.
                          </p>
                          <p className="mb-2">
                            * I will be dedicated to personal improvement in
                            devotional practice and purity, by gradually
                            applying the teachings of Srila Prabhupada under the
                            guidance of his representatives.
                          </p>
                          <p className="mb-2">
                            * I will accept that Lord Krishna is the Supreme
                            Personality of Godhead.{" "}
                          </p>
                          <p className="mb-2">
                            * I will lead a pure holy life by avoiding
                            intoxication ( alcoholic drinks ), meat-eating,
                            gambling and extramarital sex.{" "}
                          </p>
                          <p className="mb-2">
                            * I will study the books of Srila Prabhupada and
                            attend the classes in ISKCON as often as possible (
                            atleast the Sunday evening Bhagavad-gita class every
                            week).
                          </p>
                          <p className="mb-2">
                            * I will worship Lord Krishna as far as practical at
                            home, by setting up an altar, offering arati and
                            foodstuffs, worshipping the sacred tulasi plant and
                            following basic sadhana like rising early in the
                            morning.
                          </p>
                          <p className="mb-2">
                            * I will observe fasting on the Ekadashi and
                            festival days as indicated in the Vaishnava
                            Calendar.Bhoga Offering Procedure
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Writing Shiksha
                          <br />
                          Paper
                        </td>
                        <td className="py-3 pl-4">
                          <p>An open book test</p>
                          <p>
                            (
                            <a
                              href="#"
                              onClick={() => openAndDownloadDrivePdf('https://drive.google.com/file/d/1f_ZoVxGhPhArNXh-xOqbtQ0PdYmB8AZx/view?usp=drive_link', 'questionnaire.pdf')}

                              className="text-rose-500 hover:underline"
                            >
                              questionnaire
                            </a>
                            )
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Training- Attend
                          <br />
                          Seminar
                        </td>
                        <td className="py-3 pl-4">No</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Interview
                        </td>
                        <td className="py-3 pl-4">No</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Mentor/Guide
                        </td>
                        <td className="py-3 pl-4">Must have</td>
                      </tr>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Attending Bv
                        </td>
                        <td className="py-3 pl-4">Must attend weekly BV</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* Krishna Upasaka
               */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold uppercase text-red border-b-2 border-red-700 pb-2 mb-4">
                  Bhakti Step 4: Krishna Upasaka
                </h2>
                <p className="mb-4">
                  Downloadable version of{" "}
                  <a href="#"
                    onClick={() => openAndDownloadDrivePdf('https://drive.google.com/file/d/1Wh7rBJaDXgIZCIz0dV1l1m4clCujVKtS/view?usp=drive_link', 'questionnaire.pdf')}
                    className="text-rose-600 hover:underline">
                    questionnaire
                  </a>{" "}
                </p>

                <div className="border border-gray-300 rounded-md overflow-hidden mb-8">
                  <table className="w-full border-collapse border-t border-l border-r border-gray-300">
                    <tbody>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Chanting- min
                          <br />
                          Rounds
                        </td>
                        <td className="py-3 pl-4">12 to 16</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Reading
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            Pancha tattva mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1yk4IdMbZ0BaORArOJbzkVsOQuYRR3Y5Q/view?usp=drive_link",
                                  "Pancha tattva mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prabhupada pranam mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1AcC61DPlCO0QxOogCF7T0Ghvwr2Pmiyz/view?usp=drive_link",
                                  "Srila prabhupada pranama mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            <a
                              href="#"
                              className="text-rose-500 hover:underline"
                            >
                              Sikshastakam
                            </a>
                          </p>
                          <p className="mb-2">
                            Ten offenses to be avoided (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/16mqbl7FQDO7lfZlhCwC2qQbRI2N2U4wC/view?usp=drive_link",
                                  "Ten offenses to be avoided.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            Prayers for offering Bhoga (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1o_DG-fWeITOThXrKBoNa5guxVxeFojkk/view?usp=drive_link",
                                  "Prayers for offering Bhoga.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prasadam honoring mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1-C7u4FwHKjTZNH0JLdlgkg8c50sVbl29/view?usp=drive_link",
                                  "Prasadam honoring mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/bbd/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Beyond Birth & Death
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/ssr/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Science of Self Realization
                            </a>
                            <span className="pl-2">chapter 1 - 5</span>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/bg/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Bhagavat Gita As It Is{" "}
                            </a>
                            <span className="pl-2">
                              Introduction & chapter 1 - 3
                            </span>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/rv/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Raja vidya
                            </a>
                          </p>
                          <p className="mb-2">Matchless Gift</p>

                          <p className="mb-2">
                            recommended
                            <a
                              href="https://vedabase.io/en/library/kb/"
                              target="_blank"
                              className="text-rose-500 hover:underline mx-1"
                            >
                              Krishna{" "}
                            </a>
                            book
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Hearing
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">Must- SP’s BG classes</p>

                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_7"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 7 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_8"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 8 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_9"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 9 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_10"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 10 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_11"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 11 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_12"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 12 –click here)</p>
                          </a>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Rules and Regulation
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            * I will be an active devotee in the temple’s
                            congregation, that is, I will visit the temple as
                            often as possible participate and associate with
                            Krishna Conscious programs in the temple.
                          </p>
                          <p className="mb-2">
                            * Refraining from non-vegetarian food (meat, fish
                            and eggs ) and try to lead a moral life.
                          </p>
                          <p className="mb-2">
                            * I will be dedicated to personal improvement in
                            devotional practice and purity, by gradually
                            applying the teachings of Srila Prabhupada under the
                            guidance of his representatives.{" "}
                          </p>
                          <p className="mb-2">
                            * I will accept that Lord Krishna is the Supreme
                            Personality of Godhead.{" "}
                          </p>
                          <p className="mb-2">
                            * I will lead a pure holy life by avoiding
                            intoxication ( alcoholic drinks ), meat-eating,
                            gambling and extramarital sex.
                          </p>
                          <p className="mb-2">
                            * I will study the books of Srila Prabhupada and
                            attend the classes in ISKCON as often as possible (
                            atleast Sunday Bhagavatam or Bhagavad-gita every
                            week).
                          </p>
                          <p className="mb-2">
                            * I will worship Lord Krishna as far as practical at
                            home, by setting up an altar, offering arati and
                            foodstuffs, worshipping the sacred tulasi plant and
                            following basic sadhana like rising early in the
                            morning.
                          </p>
                          <p className="mb-2">
                            * I will observe fasting on the Ekadashi and
                            festival days as indicated in the Vaishnava
                            Calendar.
                          </p>
                          <p className="mb-2">
                            * I will accept the acharyas in the Gaudiya
                            Parampara
                          </p>
                          <p className="mb-2">
                            * I will fast for the appearance and disappearance
                            of the previous acharyas & Lord as given in the
                            Vaishnava Calendar.{" "}
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Writing Shiksha
                          <br />
                          Paper
                        </td>
                        <td className="py-3 pl-4">
                          <p>A closed book at Sector level</p>
                          <p>
                            (
                            <a
                              href="#"
                              onClick={() => openAndDownloadDrivePdf('https://drive.google.com/file/d/1Wh7rBJaDXgIZCIz0dV1l1m4clCujVKtS/view?usp=drive_link', 'questionnaire.pdf')}
                              className="text-rose-500 hover:underline"
                            >
                              questionnaire
                            </a>
                            )
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Training- Attend
                          <br />
                          Seminar
                        </td>
                        <td className="py-3 pl-4">Basic Vaishnava Etiquette</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Interview
                        </td>
                        <td className="py-3 pl-4">Yes,BV</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Mentor/Guide
                        </td>
                        <td className="py-3 pl-4">Must have</td>
                      </tr>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Attending Bv
                        </td>
                        <td className="py-3 pl-4">Must attend weekly BV</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Srila Prabhupada Ashraya
               */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold uppercase text-red border-b-2 border-red-700 pb-2 mb-4">
                  Bhakti Step 5: Srila Prabhupada Ashraya{" "}
                </h2>
                <p className="mb-4">
                  Downloadable version of{" "}
                  <a href="#"
                    onClick={() => openAndDownloadDrivePdf('https://drive.google.com/file/d/12zKZBDzeFNFkXQExphdfJwosmp9eR10x/view?usp=drive_link', 'shrila_prabhupad_questionnaire.pdf')}
                    className="text-rose-600 hover:underline">
                    Questionnaire
                  </a>{" "}
                </p>

                <div className="border border-gray-300 rounded-md overflow-hidden mb-8">
                  <table className="w-full border-collapse border-t border-l border-r border-gray-300">
                    <tbody>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Chanting- min
                          <br />
                          Rounds
                        </td>
                        <td className="py-3 pl-4">16</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Reading
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            Pancha tattva mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1V27SGCgIY_sAvirAbS3H8EN6wqu5UIpD/view?usp=drive_link",
                                  "Pancha tattva mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prabhupada pranam mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1AcC61DPlCO0QxOogCF7T0Ghvwr2Pmiyz/view?usp=drive_link",
                                  "Srila prabhupada pranama mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            <a
                              href="#"
                              className="text-rose-500 hover:underline"
                            >
                              Sikshastakam
                            </a>
                          </p>
                          <p className="mb-2">
                            Ten offenses to be avoided (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "httpshttps://drive.google.com/file/d/1Y-iM1msr8JrHC-Dmv4TBeNB8UJhhGD64/view?usp=drive_link",
                                  "Ten offenses to be avoided.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            Prayers for offering Bhoga (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1MKUfA4ZheTRBTG33bUuSkFeVCPsCSG6f/view?usp=drive_link",
                                  "Prayers for offering Bhoga.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prasadam honoring mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1_ezRVJY9JW1H_rkssiQyYqBWFXY7ElEC/view?usp=drive_link",
                                  "Prasadam honoring mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/bbd/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Beyond Birth & Death
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/ssr/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Science of Self Realization
                            </a>
                            <span className="pl-2">chapter 1 - 8</span>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/bg/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Bhagavat Gita As It Is{" "}
                            </a>
                            <span className="pl-2">
                              Introduction & Chapter 1 – 18
                            </span>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/rv/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Raja vidya
                            </a>
                          </p>
                          <p className="mb-2">Matchless Gift</p>

                          <p className="mb-2">
                            recommended
                            <a
                              href="https://vedabase.io/en/library/kb/"
                              target="_blank"
                              className="text-rose-500 hover:underline mx-1"
                            >
                              Krishna{" "}
                            </a>
                            book
                          </p>
                          <p>
                            Srila Prabhupada book (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1cwsIz8nTkeYL58uU2feHzJe-2GbX-WS-/view?usp=drive_link",
                                  "Your ever well wisher.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              Your ever well wisher{" "}
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            Should have taken Srila Prabhupada Asraya
                          </p>
                          <p className="mb-2">
                            Bhagavat Gita As It Is
                            <a
                              href="https://vedabase.io/en/library/bg/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              {" "}
                              (Twice)
                            </a>
                          </p>

                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/tlc/17/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Teachings of Lord Caitanya (Chapter 17)
                            </a>
                          </p>
                          <p className="mb-2"></p>
                          <a
                            href="#"
                            onClick={() =>
                              openAndDownloadDrivePdf(
                                "https://drive.google.com/file/d/1vIyapCIeRkyd-r_RdQLBUnrmtCR9jWKK/view?usp=drive_link",
                                "Optional- Scriptural Evidence that Lord Chaitanya.pdf"
                              )
                            }
                            className="text-rose-500 hover:underline"
                          >
                            Optional- Scriptural Evidence that Lord Chaitanya is
                            Lord Krishna Himself{" "}
                          </a>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Hearing
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            Must- SP’s BG classes. Optional – SP’s SB Classes
                          </p>

                          <a
                            href="https://vanisource.org/wiki/Category:SB_Lectures_-_Canto_01 "
                            target="_blank"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(SB Canto 1 – click here)</p>
                          </a>

                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_13"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 13 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_15"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 15 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_16"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 16 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_17"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 17 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_18"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 18 –click here)</p>
                          </a>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Rules and Regulation
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            * I will be an active devotee in the temple’s
                            congregation, that is, I will visit the temple as
                            often as possible participate and associate with
                            Krishna Conscious programs in the temple.
                          </p>
                          <p className="mb-2">
                            Refraining from non-vegetarian food (meat, fish and
                            eggs ) and try to lead a moral life.
                          </p>
                          <p className="mb-2">
                            * I will be dedicated to personal improvement in
                            devotional practice and purity, by gradually
                            applying the teachings of Srila Prabhupada under the
                            guidance of his representatives.
                          </p>
                          <p className="mb-2">
                            * I will accept that Lord Krishna is the Supreme
                            Personality of Godhead.{" "}
                          </p>
                          <p className="mb-2">
                            * I will lead a pure holy life by avoiding
                            intoxication ( alcoholic drinks ), meat-eating,
                            gambling and extramarital sex.{" "}
                          </p>
                          <p className="mb-2">
                            * I will study the books of Srila Prabhupada and
                            attend the classes in ISKCON as often as possible (
                            atleast the Sunday evening Bhagavad-gita class every
                            week).
                          </p>
                          <p className="mb-2">
                            * I will worship Lord Krishna as far as practical at
                            home, by setting up an altar, offering arati and
                            foodstuffs, worshipping the sacred tulasi plant and
                            following basic sadhana like rising early in the
                            morning.
                          </p>
                          <p className="mb-2">
                            * I will observe fasting on the Ekadashi and
                            festival days as indicated in the Vaishnava Calendar
                          </p>
                          <p className="mb-2">
                            * I will accept the acharyas in the Gaudiya
                            Parampara
                          </p>

                          <p className="mb-2">
                            * I will fast for the appearance and disappearance
                            of the previous acharyas & Lord as given in the
                            Vaishnava Calendar.
                          </p>
                          <p className="mb-2">
                            * I will avoid intoxication including coffee & tea,
                            cinema, sports . I will also abstain from taking
                            onion and garlic{" "}
                          </p>
                          <p className="mb-2">
                            * I will be actively engaging in preaching
                            (according to my capacity) to others about Krishna
                            Consciousness.{" "}
                          </p>
                          <p className="mb-2">
                            * I will follow a strict sadhana programme at homeby
                            rising early in the morning and following a program
                            similar to the temple as far as possible.{" "}
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Writing Shiksha
                          <br />
                          Paper
                        </td>
                        <td className="py-3 pl-4">
                          <p>A closed book level</p>
                          <p>
                            (
                            <a
                              href="#"
                              onClick={() => openAndDownloadDrivePdf('https://drive.google.com/file/d/12zKZBDzeFNFkXQExphdfJwosmp9eR10x/view?usp=drive_link', 'shrila_prabhupad_questionnaire.pdf')}
                              className="text-rose-500 hover:underline"
                            >
                              questionnaire
                            </a>
                            )
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Training- Attend
                          <br />
                          Seminar
                        </td>
                        <td className="py-3 pl-4">SP Position Seminar</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Interview
                        </td>
                        <td className="py-3 pl-4">Yes</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Mentor/Guide
                        </td>
                        <td className="py-3 pl-4">Must have</td>
                      </tr>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Attending Bv
                        </td>
                        <td className="py-3 pl-4">Recommend to lead BV</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Guru padasrya*/}

              <div className="mb-8">
                <h2 className="text-2xl font-bold uppercase text-red border-b-2 border-red-700 pb-2 mb-4">
                  Bhakti Step 6: Guru padasrya
                </h2>
                <p className="mb-4">
                  Downloadable version of{" "}
                  <a href="#"
                    onClick={() => openAndDownloadDrivePdf('https://drive.google.com/file/d/1load7fWj4lAxtJvKTfh6GbLTWWqNmOcq/view?usp=drive_link', 'questionnaire.pdf')}
                    className="text-rose-600 hover:underline">
                    Assessment Form & Questionnaire
                  </a>{" "}
                </p>

                <div className="border border-gray-300 rounded-md overflow-hidden mb-8">
                  <table className="w-full border-collapse border-t border-l border-r border-gray-300">
                    <tbody>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Chanting- min
                          <br />
                          Rounds
                        </td>
                        <td className="py-3 pl-4">16</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Reading
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            Pancha tattva mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/13I2GA_E-XXeCIs_F10uan23XGsB4bHaF/view?usp=drive_link",
                                  "Pancha tattva mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prabhupada pranam mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1AcC61DPlCO0QxOogCF7T0Ghvwr2Pmiyz/view?usp=drive_link",
                                  "Srila prabhupada pranama mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>

                          <p>
                            Guru pranam mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "",
                                  "Guru pranam mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>

                          <p className="mb-2">
                            <a
                              href="#"
                              className="text-rose-500 hover:underline"
                            >
                              Sikshastakam
                            </a>
                          </p>
                          <p className="mb-2">
                            Ten offenses to be avoided (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1hhl4mGzKCHAyOegNOj9BZzNFiFLhKV0N/view?usp=drive_link",
                                  "Ten offenses to be avoided.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            Prayers for offering Bhoga (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1CZDcZ0m6jh9Xsb6zSSMxmJAhhBnlGkx_/view?usp=drive_link",
                                  "Prayers for offering Bhoga.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prasadam honoring mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1w24ceS7ZX66dTuA1klexO-xR7MbCKEK7/view?usp=drive_link",
                                  "Prasadam honoring mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/bbd/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Beyond Birth & Death
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/ssr/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Science of Self Realization
                            </a>
                            <span className="pl-2">chapter 1 - 8</span>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/bg/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Bhagavat Gita As It Is{" "}
                            </a>
                            <span className="pl-2">
                              Introduction & Chapter 1 – 18
                            </span>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/rv/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Raja vidya
                            </a>
                          </p>
                          <p className="mb-2">Matchless Gift</p>

                          <p className="mb-2">
                            recommended
                            <a
                              href=" https://vedabase.io/en/library/kb/"
                              target="_blank"
                              className="text-rose-500 hover:underline mx-1"
                            >
                              Krishna{" "}
                            </a>
                            book
                          </p>
                          <p>
                            Srila Prabhupada book (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1VbxZvvldPtgJ4ReNbHFkNxlMR8eLcD7w/view?usp=drive_link",
                                  "Your ever well wisher.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              Your ever well wisher{" "}
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            Should have taken Srila Prabhupada Asraya
                          </p>
                          <p className="mb-2">
                            Bhagavat Gita As It Is
                            <a
                              href=": https://vedabase.io/en/library/bg/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              {" "}
                              (Twice)
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/noi/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Nectar of Instruction
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href=" https://vedabase.io/en/library/nod/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              {" "}
                              Nectar of Devotion
                            </a>
                            (up to 19th Chapter)
                          </p>

                          <p className="mb-2">
                            <a
                              href=" https://vedabase.io/en/library/tlc/17/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Teachings of Lord Caitanya (Chapter 17)
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1eylkRDjwqaEWMjbGYSjja239YFigw55X/view?usp=drive_link",
                                  "Optional- Scriptural Evidence that Lord Chaitanya is Lord Krishna Himself.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              Optional- Scriptural Evidence that Lord Chaitanya
                              is Lord Krishna Himself{" "}
                            </a>{" "}
                          </p>
                          <p className="mb-2">
                            <a
                              href=""
                              className="text-rose-500 hover:underline"
                            >
                              {" "}
                              http://gbc.iskcon.org/harmonizing-iskcons-lines-of-authority/
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href=""
                              className="text-rose-500 hover:underline"
                            >
                              {" "}
                              http://www.dandavats.com/wp-content/uploads/GBCresolutions/GBCRES13.html
                            </a>
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Hearing
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            Must- SP’s BG classes. Optional – SP’s SB Classes
                          </p>

                          <a
                            href="https://vanisource.org/wiki/Category:SB_Lectures_-_Canto_01 "
                            target="_blank"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(SB Canto 1 – click here)</p>
                          </a>

                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_13"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 13 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_15"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 15 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_16"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 16 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_17"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 17 –click here)</p>
                          </a>
                          <a
                            href="https://vanisource.org/wiki/Category:BG_Lectures_-_Chapter_18"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(BG chapters 18 –click here)</p>
                          </a>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Rules and Regulation
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            * I will be an active devotee in the temple’s
                            congregation, that is, I will visit the temple as
                            often as possible participate and associate with
                            Krishna Conscious programs in the temple.
                          </p>
                          <p className="mb-2">
                            * Refraining from non-vegetarian food (meat, fish
                            and eggs ) and try to lead a moral life.
                          </p>
                          <p className="mb-2">
                            * I will be dedicated to personal improvement in
                            devotional practice and purity, by gradually
                            applying the teachings of Srila Prabhupada under the
                            guidance of his representatives.
                          </p>
                          <p className="mb-2">
                            * I will accept that Lord Krishna is the Supreme
                            Personality of Godhead.{" "}
                          </p>
                          <p className="mb-2">
                            * I will lead a pure holy life by avoiding
                            intoxication ( alcoholic drinks ), meat-eating,
                            gambling and extramarital sex.{" "}
                          </p>
                          <p className="mb-2">
                            * I will study the books of Srila Prabhupada and
                            attend the classes in ISKCON as often as possible (
                            atleast the Sunday evening Bhagavad-gita class every
                            week).
                          </p>
                          <p className="mb-2">
                            * I will worship Lord Krishna as far as practical at
                            home, by setting up an altar, offering arati and
                            foodstuffs, worshipping the sacred tulasi plant and
                            following basic sadhana like rising early in the
                            morning.
                          </p>
                          <p className="mb-2">
                            * I will observe fasting on the Ekadashi and
                            festival days as indicated in the Vaishnava Calendar
                          </p>
                          <p className="mb-2">
                            * I will accept the acharyas in the Gaudiya
                            Parampara
                          </p>

                          <p className="mb-2">
                            * I will fast for the appearance and disappearance
                            of the previous acharyas & Lord as given in the
                            Vaishnava Calendar.
                          </p>
                          <p className="mb-2">
                            * I will avoid intoxication including coffee & tea,
                            cinema, sports . I will also abstain from taking
                            onion and garlic{" "}
                          </p>
                          <p className="mb-2">
                            * I will be actively engaging in preaching
                            (according to my capacity) to others about Krishna
                            Consciousness.{" "}
                          </p>
                          <p className="mb-2">
                            * I will follow a strict sadhana programme at homeby
                            rising early in the morning and following a program
                            similar to the temple as far as possible.{" "}
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Writing Shiksha
                          <br />
                          Paper
                        </td>
                        <td className="py-3 pl-4">
                          <p>
                            A closed book test at level (15 questions from
                            GBC)
                          </p>
                          <p>
                            (
                            <a
                              href="#"
                              onClick={() => openAndDownloadDrivePdf('https://drive.google.com/file/d/1load7fWj4lAxtJvKTfh6GbLTWWqNmOcq/view?usp=drive_link', 'questionnaire.pdf')}
                              className="text-rose-500 hover:underline"
                            >
                              questionnaire
                            </a>
                            )
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Training- Attend
                          <br />
                          Seminar
                        </td>
                        <td className="py-3 pl-4">
                          Vaishnava etiquette seminar
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Interview
                        </td>
                        <td className="py-3 pl-4">Yes</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Mentor/Guide
                        </td>
                        <td className="py-3 pl-4">Must have</td>
                      </tr>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Attending Bv
                        </td>
                        <td className="py-3 pl-4">Recommend to lead BV</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Recommendation for 1st Initiation */}

              <div className="mb-8">
                <h2 className="text-2xl font-bold uppercase text-red border-b-2 border-red-700 pb-2 mb-4">
                  bhakti step 7: Recommendation for 1st Initiation
                </h2>

                <div className="border border-gray-300 rounded-md overflow-hidden mb-8">
                  <table className="w-full border-collapse border-t border-l border-r border-gray-300">
                    <tbody>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Chanting- min
                          <br />
                          Rounds
                        </td>
                        <td className="py-3 pl-4">16</td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Reading
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            Pancha tattva mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1H7QQp0rg1U7_oy6VpR71PfItkzX0nFg0/view?usp=drive_link",
                                  " Pancha tattva mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prabhupada pranam mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1AcC61DPlCO0QxOogCF7T0Ghvwr2Pmiyz/view?usp=drive_link",
                                  "Srila prabhupada pranama mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>Guru Pranam Mantra ( )</p>
                          <p className="mb-2">
                            <a
                              href="#"
                              className="text-rose-500 hover:underline"
                            >
                              Sikshastakam
                            </a>
                          </p>
                          <p className="mb-2">
                            Ten offenses to be avoided (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1G8Pl4Qk1l8J8ofBacoV7sLC8SIUI2Vru/view?usp=drive_link",
                                  "Ten offenses to be avoided.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            Prayers for offering Bhoga (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1XQ-7gTXnfyiUIJ5Dc0ppZ9TzY8DactKc/view?usp=drive_link",
                                  "Prayers for offering Bhoga.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p>
                            Prasadam honoring mantra (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1zFzRNaFeqTMNd5Cpe1I-4knII1QwQ20o/view?usp=drive_link",
                                  "Prasadam honoring mantra.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              click here
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            <a
                              href=" https://vedabase.io/en/library/bbd/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Beyond Birth & Death
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/ssr/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Science of Self Realization
                            </a>
                            <span className="pl-2">chapter 1 - 8</span>
                          </p>

                          <p className="mb-2">
                            <a
                              href=" https://vedabase.io/en/library/rv/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Raja vidya
                            </a>
                          </p>
                          <p className="mb-2">Matchless Gift</p>

                          <p className="mb-2">
                            recommended
                            <a
                              href="https://vedabase.io/en/library/kb/"
                              target="_blank"
                              className="text-rose-500 hover:underline mx-1"
                            >
                              Krishna{" "}
                            </a>
                            book
                          </p>
                          <p>
                            Srila Prabhupada book (
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/1yQkp8YhyGqCF6D81tTpWw-NtS3C7rskl/view?usp=drive_link",
                                  "Your ever well wisher.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              Your ever well wisher{" "}
                            </a>
                            )
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vanisource.org/wiki/Category:SB_Lectures_-_Canto_01 "
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Srimad Bhagavatam Canto 1{" "}
                            </a>
                          </p>
                          <p className="mb-2">
                            Bhagavat Gita As It Is
                            <a
                              href="https://vedabase.io/en/library/bg/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              {" "}
                              (Twice)
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href="https://vedabase.io/en/library/tlc/17/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              Life and Teachings of Lord Chaitanya
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href=""
                              className="text-rose-500 hover:underline"
                            >
                              Nectar of Instruction
                            </a>
                          </p>
                          <p className="mb-2">
                            <a
                              href=" https://vedabase.io/en/library/noi/"
                              target="_blank"
                              className="text-rose-500 hover:underline"
                            >
                              {" "}
                              Nectar of Devotion
                            </a>
                            (up to 19th Chapter)
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Hearing
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">Must- SP’s BG classes</p>

                          <a
                            href="https://vanisource.org/wiki/Category:SB_Lectures_-_Canto_02"
                            target="_blank"
                            className="text-rose-500 hover:underline"
                          >
                            <p>(SB Canto 2 – click here)</p>
                          </a>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Rules and Regulation
                        </td>
                        <td className="py-3 pl-4">
                          <p className="mb-2">
                            * I will be an active devotee in the temple’s
                            congregation, that is, I will visit the temple as
                            often as possible participate and associate with
                            Krishna Conscious programs in the temple.
                          </p>
                          <p className="mb-2">
                            * Refraining from non-vegetarian food (meat, fish
                            and eggs ) and try to lead a moral life.
                          </p>
                          <p className="mb-2">
                            * I will be dedicated to personal improvement in
                            devotional practice and purity, by gradually
                            applying the teachings of Srila Prabhupada under the
                            guidance of his representatives.
                          </p>
                          <p className="mb-2">
                            * I will accept that Lord Krishna is the Supreme
                            Personality of Godhead.{" "}
                          </p>
                          <p className="mb-2">
                            * I will lead a pure holy life by avoiding
                            intoxication ( alcoholic drinks ), meat-eating,
                            gambling and extramarital sex.{" "}
                          </p>
                          <p className="mb-2">
                            * I will study the books of Srila Prabhupada and
                            attend the classes in ISKCON as often as possible (
                            atleast the Sunday evening Bhagavad-gita class every
                            week).
                          </p>
                          <p className="mb-2">
                            * I will worship Lord Krishna as far as practical at
                            home, by setting up an altar, offering arati and
                            foodstuffs, worshipping the sacred tulasi plant and
                            following basic sadhana like rising early in the
                            morning.
                          </p>
                          <p className="mb-2">
                            * I will observe fasting on the Ekadashi and
                            festival days as indicated in the Vaishnava Calendar
                          </p>
                          <p className="mb-2">
                            * I will accept the acharyas in the Gaudiya
                            Parampara
                          </p>

                          <p className="mb-2">
                            * I will fast for the appearance and disappearance
                            of the previous acharyas & Lord as given in the
                            Vaishnava Calendar.
                          </p>
                          <p className="mb-2">
                            * I will avoid intoxication including coffee & tea,
                            cinema, sports . I will also abstain from taking
                            onion and garlic{" "}
                          </p>
                          <p className="mb-2">
                            * I will be actively engaging in preaching
                            (according to my capacity) to others about Krishna
                            Consciousness.{" "}
                          </p>
                          <p className="mb-2">
                            * I will follow a strict sadhana programme at homeby
                            rising early in the morning and following a program
                            similar to the temple as far as possible.{" "}
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Writing Shiksha
                          <br />
                          Paper
                        </td>
                        <td className="py-3 pl-4">
                          <p>
                            A closed book test at (1st Initiation – Writing
                            Shiksha paper). Refer to the document:{" "}
                            <a
                              href="#"
                              onClick={() =>
                                openAndDownloadDrivePdf(
                                  "https://drive.google.com/file/d/13bP5XbaVN_lmZq2l4WWrRngFFAznvAOI/view?usp=drive_link",
                                  "First Initiation Candidate Pre-requisites.pdf"
                                )
                              }
                              className="text-rose-500 hover:underline"
                            >
                              First Initiation Candidate Pre-requisites
                            </a>{" "}
                          </p>
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Training- Attend
                          <br />
                          Seminar
                        </td>
                        <td className="py-3 pl-4">
                          IDC, Holy Name (Harinaam Chinatamni), Vaishnava
                          etiquete (or manual)
                        </td>
                      </tr>

                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Interview
                        </td>
                        <td className="py-3 pl-4">Yes</td>
                      </tr>
                      {/* <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Service at IBC/Temple
                        </td>
                        <td className="py-3 pl-4">
                          Must have min one weekly service at IBC/temple
                        </td>
                      </tr> */}
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Mentor/Guide
                        </td>
                        <td className="py-3 pl-4">
                          Senior disciple of Guru for association or guidance
                          should be identified before initiation
                        </td>
                      </tr>
                      <tr className="border-b border-gray-300">
                        <td className="w-1/3 py-3 pr-4 align-top text-gray-700 border-r border-gray-300 pl-2">
                          Attending Bv
                        </td>
                        <td className="py-3 pl-4">Recommend to lead BV</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div>
                <p>
                  When recommendation letter for initiation is issued from,
                  it meant vouch for applicant’s stability in terms of
                  Sadhana and leading moral life. To get fair evaluation,
                  devotee must be connected to at least 6 months
                </p>
              </div>
            </div>


 {/* Right Sidebar - Registration Form */}
            <div className="lg:w-1/3">
              <div className="bg-red p-6 rounded-md shadow-md">
                <h3 className="text-xl text-center text-white font-bold text-red-700 mb-6">
                  Register With Us
                </h3>
                <form onSubmit={handleSubmit}>
                  <div className="mb-4 relative">
                    <div
                      className="w-full px-4 py-2 border border-gray-300 rounded-md bg-white cursor-pointer"
                      onClick={() => setDropdownOpen(!dropdownOpen)}
                      ref={dropdownRef}
                    >
                      {selectedLabel}
                    </div>

                    {dropdownOpen && (
                      <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow max-h-60 overflow-y-auto">
                        {options.map((option) => (
                          <div
                            key={option.value}
                            onClick={() => handleSelect(option.value)}
                            className={`px-4 py-2 cursor-pointer hover:bg-red hover:text-white ${
                              formData.bhaktiStep === option.value
                                ? "bg-red-100"
                                : ""
                            }`}
                          >
                            {option.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="mb-4">
                    <input
                      type="text"
                      name="passportName"
                      value={formData.passportName}
                      onChange={handleChange}
                      placeholder="Passport Name"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <input
                      type="text"
                      name="spiritualName"
                      value={formData.spiritualName}
                      onChange={handleChange}
                      placeholder="Initiated Name (if any)"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                      
                    />
                  </div>
                  <div className="mb-4">
                    <input
                      type="text"
                      name="spiritualMaster"
                      value={formData.spiritualMaster}
                      onChange={handleChange}
                      placeholder="Spiritual Master (Aspiring)"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <input
                      type="text"
                      name="connectedWith"
                      value={formData.connectedWith}
                      onChange={handleChange}
                      placeholder="Connected to Mentor/Bhakti Vriksa"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <div className="mb-4">
                      <input
                        type="tel"
                        name="contactNumber"
                        value={formData.contactNumber}
                        onChange={handleChange}
                        placeholder="Contact Number"
                        className={`w-full px-2 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 ${
                          errors.contactNumber
                            ? "border-red-500"
                            : "border-gray-300"
                        }`}
                        required
                      />
                      {errors.contactNumber && (
                        <p className="mt-1 text-sm text-red-600">
                          {errors.contactNumber}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="mb-4">
                    <input
                      type="text"
                      name="committedRounds"
                      value={formData.committedRounds}
                      onChange={handleChange}
                      placeholder="Committed Number of Rounds"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <input
                      type="text"
                      name="genderLanguageLocation"
                      value={formData.genderLanguageLocation}
                      onChange={handleChange}
                      placeholder="Gender-Language-Located Area"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full bg-yellow-500 text-white py-2 px-4 rounded-md hover:bg-red-800 transition duration-300"
                    disabled={isSubmitting}

                  >
                   {isSubmitting ? "Submitting....." : "Submit"}
                  </button>
                </form>
              </div>
            </div>
           
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
}
